export default __webpack_public_path__ + "static/media/vault-plus-active-button.84483cba.svg";